/**
* QIUI 下载页面
*/
<template>

	<div>

		<van-notify v-model="show" type="success">
			<van-icon name="bell" style="margin-right: 4px;" />
			<span>{{ $t('language000054') }}</span>
		</van-notify>

	</div>


</template>

<script>
	//执行顺序是beforeCreate -> created -> beforeMount -> mounted

	import Vue from 'vue';
	import 'vant/lib/index.css'; //导入样式
	import {
		Notify
	} from 'vant';


	export default {
		name: 'Download',
		components: {
			[Notify.Component.name]: Notify.Component,
		},
		data() {
			return {
				show: true,
			};
		},
		mounted() {
			this.jump();
		},
		methods: {
			jump() {

				const userAgent = navigator.userAgent; //用户代理
				const platform = navigator.platform; //计算机平台 mac/windows
				const screenWidth = window.screen.width; //屏幕宽度
				const isAndroid = userAgent.includes('Android');
				const isiOS = /iPad|iPhone|iPod/.test(userAgent);
				const isWindows = platform.includes('Win');
				const isMac = platform.includes('Mac');
				const isMobile = screenWidth < 768;
				/* console.log('User Agent:', userAgent);
				console.log('Platform:', platform);
				console.log('Screen Width:', screenWidth);
				console.log('Is Android:', isAndroid);
				console.log('Is iOS:', isiOS);
				console.log('Is Windows:', isWindows);
				console.log('Is Mac:', isMac);
				console.log('Is Mobile:', isMobile); */


				setTimeout(() => {
					if (isAndroid) {
						const userAgent = navigator.userAgent.toLowerCase();
						if (userAgent.includes('chrome')) {
							//谷歌手机
							const googlePlayURL =
								`https://play.google.com/store/apps/details?id=${"cellmate.qiui.com"}`;
							//window.open(googlePlayURL, '_blank'); // 在新窗口中打开谷歌商店应用下载页面
							window.location.href = googlePlayURL; // 当前窗口打开
						} else {
							//不是谷歌手机 跳转到应用宝
							// const packageName = 'cellmate.qiui.com';
							// const tencentAppStoreURL = `tmast://appdetails?pkg=${packageName}`;
							// window.location.href = tencentAppStoreURL;

							//应用宝没有通过审核 先去官网
							window.location.href = "https://www.qiuitoy.com/";
						}
					} else if (isiOS) {
						//苹果手机跳转到苹果商店
						const appIdOrBundleId = '1460438419';
						const appStoreURL = `https://apps.apple.com/app/id${appIdOrBundleId}`;
						window.location.href = appStoreURL;
					} else {
						//网页端跳转到官网下载
						window.location.href = "https://www.qiuitoy.com/";
					}
				}, 1000); //延迟3秒执行



			},
		}
	}
</script>

<style>
</style>